(function ($) {
	
	$(document).ready(function() {
		/*if ($('.cols-services ul').length) {
			//var colHeight = $('.cols-services ul li').outerHeight(true) / 2 + 20;
			
			

			$(window).resize(function() {
				var colHeight = 0;
				$('.cols-services ul li').each(function(index) {
	                colHeight += $(this).outerHeight(true);
	                colHeightI = $(this).outerHeight(true);
	          	console.log(index +':' + colHeightI);
	            });
	            var finalHeight = colHeight / 2 + 50;
				$('.cols-services ul').css('height', finalHeight);
			});

			$(window).trigger('resize');
		}*/
		

		set_equal_height();
		
        $('.open-chat').on('click', function(){
        	$('.boldchat a').trigger('click');
        })     

        // sticky merchant filters

        if ($('.merchant-filters').length) {
	        var stickyTop = $('.merchant-filters').offset().top - 10;

			$(window).scroll(function() {
			    var windowTop = $(window).scrollTop();

			    if (stickyTop < windowTop) {
			      $('.merchant-filters').addClass('sticky-filters');
			    } else {
			      $('.merchant-filters').removeClass('sticky-filters');
			    }
			});   
		}

		$('.mm-tabstart').append( "<span class='screen-reader-text'>Tab start</span>" );
		$('.mm-tabend').append( "<span class='screen-reader-text'>Tab end</span>" );

		$('[rel="video"]').on('click', function(){
			console.log('clicked');
			setTimeout(function(){
				vex.closeAll();
			}, 10);
		})
		if ($('#timeline').length) {
			$('#timeline .gallery-item').addClass('nofancybox');
			
			headerHeight = $('.main_header').outerHeight();
			$('#timeline .section').css('padding-top', headerHeight);
			
			
		}

		if ($('.specialties-wrap').length) {
			if($('.specialties-wrap fieldset input[type=checkbox]:checked').length) {
				$('.main-filter.active').addClass('highlight');
			} else {
				$('.main-filter.active').removeClass('highlight');
			}
			$('.main-filter').each(function(){
				$(this).on('click', function(){
					$('.main-filter').removeClass('highlight');
					$('.main-filter').removeClass('highlightClick');
					$(this).addClass('highlightClick');
				})
			})
			
		}

		if($('.filters.team .filter').length) {
			$('.main-filter').on('click', function(){
				function checkBoxes(){
				$('.filters.team .filter').each(function( index ) {
				  	
				  	var selectedFilters = $( this ).text();
				  	$('.team-specialties label').each(function( index ) {
				  		var selectedFiltersAjax = $( this ).text();
					  					  
					  		
					  	if (selectedFilters == selectedFiltersAjax) {
					  		var that = $( this ).closest('.filter').find('input[type=checkbox]');
							
							  that.prop( 'checked', true );
									
					  	}

					});
				});
				}
				setTimeout(checkBoxes, 1000);
			});

		}

	});



	$('#main-navigation-container .drop-down-menu .menu-item-has-children a').click(function(event){
	    event.preventDefault();
	});

	$("#main-navigation-container .nav-top-level-link a").keydown(function(e){
	   if(e.keyCode === 13){
	   		e.preventDefault();
	   		$("#main-navigation-container .nav-top-level-link").removeClass('tab-action');
	   		$( "#main-navigation-container .nav-top-level-link .drop-down-menu" ).hide();
	        $(this).parent( ".nav-top-level-link" ).addClass('tab-action');
        	$(this).parent( ".nav-top-level-link.tab-action" ).find('.drop-down-menu').show();
        	$(this).parent( ".nav-top-level-link.tab-action" ).find('.drop-down-menu').focus();
	   }
	});


	$(window).keyup(function (e) {

        if (e.keyCode == 9 && !$("#main-navigation-container .nav-top-level-link *:focus").length) {
            $("#main-navigation-container .nav-top-level-link").removeClass('tab-action');
	   		$( "#main-navigation-container .nav-top-level-link .drop-down-menu" ).hide();
        }
    });
	
	$('.skip-to-content').click(function(e){   
        e.preventDefault();
        $('html, body').animate({ scrollTop: jQuery('#page').offset().top }, "slow");
        $(this).blur(); 
        $("#page").attr("tabindex",-1).focus();
    });
	
	$(window).resize(function() {
		set_equal_height();
	});

	// mobile menu

	var $button = $("#mobile-nav-icon");
	var $buttonClose = $(".mburger-close");
	var $menu 	= $(".mobile-only");
	$menu.mmenu(
		{
			keyboardNavigation: true,
			extensions: ["multiline"],
			offCanvas: {
				moveBackground: false
			},
			"navbars": [ 
				{
	              	"position" : "bottom",
	                "content": [
	                    '<li class="login-mobile nav-top-level-link mm-listitem"><a id="login-toggle-panel" class="login-mobile-btn top-level-anchor mm-listitem__btn" href="#panel-login"><i class="fal fa-lock"></i> Login</span></li>'
	                ]
              	}
            ]
		}
	);
	var api = $menu.data( "mmenu" );

	$button
		.addClass( "wpmm-button" )
		.off( "click" )
		.on( "click", function( e ) {
			e.preventDefault();
			e.stopImmediatePropagation();
			let mobileHeader = document.querySelector('#mobile-header'),
				mobileMenu = document.querySelector('#mm-0'),
				height = mobileHeader.clientHeight;
			mobileMenu.style.top = `${height}px`;
			api.open();
		});
	$buttonClose
		.on( "click", function( e ) {
			e.preventDefault();
			e.stopImmediatePropagation();
			api.close();
		});
		$(document).on('click', '.mobile-only' , function(){
			setTimeout(function(){
				if ($('#panel-login').hasClass('mm-panel_opened')) {
					$('.mm-navbars_bottom').hide();
				} else {
					$('.mm-navbars_bottom').show();
				}
			}, 500);
			
		})

		// community filter
		var allCommunities = $('.communities option').map(function(name, data, value) { 
			name = $(this).text();
			data = $(this).data('parent');
			value = $(this).val();
			var newOption = [[name, data, value]];
			return newOption; 
		});
		var allStates = $('.states option').map(function(nameS, valueS) { 
			nameS = $(this).text();
			valueS = $(this).val();
			var newOptionS = [[nameS, valueS]];
			return newOptionS; 
		});
		
		$('.states').change(function(){
			var stateSelected = $('.states option:selected').text();
			var stateSelectedAll = $('.states option:selected').val();
					
			$('.communities option:gt(0)').remove();
			for (var i = allCommunities.length - 1; i >= 0; i--) {
				if (stateSelectedAll == 0) {

					$('.communities').append('<option value="' + allCommunities[i][2] + '" data-parent="' + allCommunities[i][1] + '">'+ allCommunities[i][0] +'</option>');
				
				}
				if (allCommunities[i][1] == stateSelected) {

					$('.communities').append('<option value="' + allCommunities[i][2] + '" data-parent="' + allCommunities[i][1] + '">'+ allCommunities[i][0] +'</option>');
					
				} 

			}

		})
		$('.communities').change(function(){
			var communitySelected = $('.communities option:selected').data('parent');
			
			for (var i = allStates.length - 1; i >= 0; i--) {
				
				if (allStates[i][0] == communitySelected) {
					$('.states').val(allStates[i][1]).prop('selected', true);
				}
				
			}
		})
/*
		$('.community-filter').submit(function(){
			var filter = $('.community-filter');
			$.ajax({
				url:filter.attr('action'),
				data:filter.serialize(), // form data
				type:filter.attr('method'), // POST
				beforeSend:function(xhr){
					filter.find('button').text('Processing...'); // changing the button label
				},
				success:function(data){
					filter.find('button').text('Apply filter'); // changing the button label back
					$('#response').html(data); // insert data
				}
			});
			return false;
		});*/


	if ($(window).width() < 1023) {	
		var position = $(window).scrollTop(); 

		$(window).scroll(function() {
		    var scroll = $(window).scrollTop();
		    if(scroll > position) {
		        $('#mobile-header').removeClass('fixed-header');
		        $('#mobile-header').addClass('absolute-header');
		    } else {
		        $('#mobile-header').removeClass('absolute-header');
		        $('#mobile-header').addClass('fixed-header');
		    }
		    position = scroll;
		});	
	}
	
    if ($('.nearest-location-list').length) {
    	$('.show-section').on('click', function(){
        	$(this).closest('.location-list-result').each(function(){
        		$('.section-hidden', this).toggle();
        	})
        })
        $('.hide-section').on('click', function(){
        	$(this).closest('.location-list-result').each(function(){
        		$('.section-hidden', this).hide();
        	})
        })
    }   
    if ($('.main-filter.js-ts-parent-link').length) {
    	// $('.main-filter.js-ts-parent-link').removeClass('active');
    	$('.main-filter.js-ts-parent-link').on('click', function(){
    		$('.specialties-wrap').show();
    	})
    	$('.main-filter.clear').on('click', function(){
    		$('.specialties-wrap').hide();
    	})
    }
    if ($('.filters-top').length) {
		var trigger = $('.filters-trigger');
		trigger.on('click', function(){
			$(this).toggleClass('show-filters');
			$(this).next('.filters').toggle();
		})
		if(trigger.hasClass('open-on-load')){
			trigger.click();
		}
    }   
	
	$('.search-mobile-header-icon').on('click', function(){
		$(this).toggleClass('search-open');
		$('.mobile-search-header').toggle();
		$('.mobile-search-header #mobile-search input').focus();
	});
	
	/* Compare BTN */
	
	$('.btn-compare').on('click', function(){

        if($('.ckeck_box input:checked').length == 0) {
        	return false;	
        }

    	$('.ckeck_box input:not(:checked)').each(function(){
			$(this).closest('tr').hide();
    	})
    });

	$('.ckeck_box input').on("click", function() { 
        
        if($('.ckeck_box input:checked').length == 0) {
        	
        	$('.ckeck_box input').each(function(){
				$(this).closest('tr').show();
			});
			
			$('.btn-compare').addClass("disabled");
			
        } else {
			$('.btn-compare').removeClass("disabled");
		}
	});

	/* 
	* Merchants 
	*/
	
	// category select
	$("#merchant-filter-category").on("change", function() {
		
		merchant_show_hide_row_and_merchants();
		narrow_cities_list();
	});
	
	// city select
	$("#merchant-filter-city").on("change", function() {
		
		merchant_show_hide_row_and_merchants();
		
		narrow_categories_list();
		
		if(!$(this).val()) {
			narrow_cities_list();
		}
	});
	
	// text search
	let searchTimeout = null;
	
	$("#merchant-search").on("keyup", function() {
		
		if(searchTimeout != null) clearTimeout(searchTimeout);  
		
		searchTerm = $(this).val();
		
		searchTimeout = setTimeout(function() {
			merchant_show_hide_row_and_merchants();
			
			narrow_cities_list();
			narrow_categories_list();
		}, 500);  
	});
	
	function narrow_categories_list() {
		
		$("#merchant-filter-category option:not([value=''])").hide();
		
		$(".merchant-category-row:visible").each(function() {
			$("#merchant-filter-category option[value='"+ $(this).data("category") +"']").show();
		});
	}
	
	function narrow_cities_list() {
		
		var cities = "";
		
		$(".merchant-item-wrapper:visible").each(function() {
			cities += jQuery(this).data("cities");
		});
		
		cities = cities.split(" ");
		
		if(cities) {
			$("#merchant-filter-city option:not([value=''])").hide();
			$.each(cities,function(iter, value){
				$("#merchant-filter-city option[value='"+ value +"']").show();
			});
		}
		
	}
		
	function merchant_show_hide_row_and_merchants() {
		
		// filter by category
		if($("#merchant-filter-category").val()) {
			$(".merchant-category-row").hide();
			$("#merchant-"+ $("#merchant-filter-category").val()).show();
		} else {
			$(".merchant-category-row").show();
		}
		
		$(".merchant-item-wrapper").show();
		
		// filter by city
		if($("#merchant-filter-city").val()) {
			$(".merchant-item-wrapper:not([data-cities*=' " + $("#merchant-filter-city").val() + "'])").hide();
		}
		
		// filter by text
		if($("#merchant-search").val()) {
			
			var search_terms = $("#merchant-search").val().split(" ");
			
			$.each(search_terms,function(iter, search_term){
				$(".merchant-item-wrapper:not([data-search*='" + search_term + "'])").hide();
			});
		}
		
		// show / hide category rows
		$(".merchant-category-row").each(function() {
			if(!$('.merchant-item-wrapper:visible', this).length) {
				$(this).hide();
			} else {
				$(this).show();
			}
		});
		
		// show hide "no results" message
		if(!$(".merchant-category-row:visible").length) {
			$(".no-results").removeClass("hide").show();
		} else {
			$(".no-results").hide();
		}
	}
	
	function set_equal_height() {
		if ($(".contact--icon-col").length) {
			equalheight(".border-box");
		}
		
		if($(".nearest-location-list").length) {
			equalheight(".nearest-location-list .branch-image-logo", "min"); 
		}

		if ($(".values-blocks").length) {
			equalheight(".value-block");
		}
	}
	
	var equalheight = function(container, minOrMax) {
		
		var currentHeight = 0,
			currentRowStart = 0,
			rowDivs = [],
			$el,
			topPosition = 0,
			currentDiv;
			
		if(typeof(minOrMax) == "undefined") {
			minOrMax = "max";
		}

		$(container).each(function() {
			$el = $(this);
			$el.height('auto');
			topPosition = $el.position().top;
			
			if (currentRowStart < topPosition - 1 || currentRowStart > topPosition + 1) {
				
				for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
					rowDivs[currentDiv].height(currentHeight);
				}
				
				rowDivs = [];
				currentRowStart = topPosition;
				currentHeight = $el.height() > 0 ? $el.height() : currentHeight;
				rowDivs.push($el);
				
			} else {
				rowDivs.push($el);
				
				if($el.height() > 0) {
					currentHeight = minOrMax == "max" ? Math.max(currentHeight, $el.outerHeight()) : Math.min(currentHeight, $el.outerHeight());
				}
			}
		});

		for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
			rowDivs[currentDiv].css('height', currentHeight);
		}
	};
	
})(jQuery);